<div class="col-md-12">
	<h2>{{{JspPublicCodes_JSP_ITEM_ALERTS_TITLE}}}</h2>
	<br>
	<p>{{{JspPublicCodes_JSP_ITEM_ALERTS_DESC}}}</p>
	<br>
</div>